export interface CreateOrUpdateMasterDataConfigBody {
  category: MasterDataCategoryV2;
  configFeilds: FieldSpec[];
}

export enum MasterDataCategoryV2 {
  Partner = 'Partner',
  User = 'User',
  Expert = 'Expert',
  Listener = 'Listener',
  Group = 'Group',
  Challenge = 'Challenge',
  Event = 'Event',
  Talk = 'Talk',
}

export enum MasterDataDataType {
  String = 'string',
  Number = 'number',
  StringArray = 'StringArray',
  Boolean = 'boolean',
}

export enum MasterDataFieldType {
  ColorPicker = "color_picker",
  Textbox = 'textbox',
  FilePicker = 'file_picker',
  Switch = 'switch',
  Dropdown = 'dropdown',
}

export enum DropdownOptionsV2 {
  PARTNER = 'PARTNER',
  USER = 'USER',
  EXPERT = 'EXPERT',
  THERAPIST = 'THERAPIST',
  LISTENER = 'LISTENER',
  OTHERS = 'OTHERS',
  ANYO_RULES = 'ANYO_RULES',
  ALL_POSSIBLE_OPTION = 'ALL_POSSIBLE_OPTION',
}

export interface FieldSpec {
  key: string;
  dataType?: MasterDataDataType;
  fieldType?: MasterDataFieldType;
  unique?: boolean;
  mandatory?: boolean;
  dropdownOptions?: DropdownOptionsV2;
  customDropdownOptions?: string[]
}

export interface MasterDataConfigDoc {
  configFeilds: FieldSpec[];
}

export interface ListMasterDataConfigsResponse {
  data: Array<{ category: MasterDataCategoryV2; masterDataType: string; config: FieldSpec[] }>;
}


